import { useState } from 'react';
import { newsList } from '@/mocks/cinema';

const tags = ['全部', '票房观察', '排片解读', '上映资讯', '购票指南', '档期窗口'];

export default function News() {
  const [tag, setTag] = useState('全部');
  const list = newsList.filter((n) => tag === '全部' || n.tag === tag);
  const featured = list[0];
  const rest = list.slice(1);

  return (
    <section id="news" className="bg-background-50">
      <div className="mx-auto max-w-7xl px-4 py-14 md:px-6 md:py-16">
        <div className="flex flex-col justify-between gap-4 md:flex-row md:items-end">
          <div>
            <span className="inline-flex items-center gap-2 rounded-full bg-secondary-100 px-3 py-1 text-xs font-medium text-secondary-800">
              <i className="ri-article-line"></i>
              票房解读
            </span>
            <h2 className="mt-3 text-2xl font-bold text-foreground-950 md:text-3xl">
              深度拆解 · 热点资讯
            </h2>
            <p className="mt-2 max-w-xl text-sm text-foreground-600">
              不止给你数字，更帮你读懂票房背后的排片逻辑、档期博弈与场次趋势。
            </p>
          </div>
          <div className="flex flex-wrap items-center gap-1 rounded-full bg-background-200 p-1">
            {tags.map((t) => (
              <button
                key={t}
                type="button"
                onClick={() => setTag(t)}
                className={`whitespace-nowrap rounded-full px-3 py-1.5 text-xs font-medium transition-colors ${
                  tag === t
                    ? 'bg-foreground-900 text-background-50'
                    : 'text-foreground-600 hover:text-foreground-900'
                }`}
              >
                {t}
              </button>
            ))}
          </div>
        </div>

        {featured && (
          <div className="mt-8 grid grid-cols-1 gap-5 lg:grid-cols-3">
            <article className="group relative min-h-[260px] overflow-hidden rounded-lg md:min-h-[340px] lg:col-span-2 lg:row-span-2">
              <img
                src="https://readdy.ai/api/search-image?query=overhead%20view%20of%20a%20crowded%20cinema%20ticket%20lobby%20with%20red%20seats%20and%20glowing%20marquee%2C%20people%20queueing%20at%20night%2C%20warm%20amber%20and%20deep%20red%20atmosphere%2C%20cinematic%20photography%2C%20rich%20detail&width=1200&height=640&seq=news-feature-01&orientation=landscape"
                alt="影院排队购票与实时票房观察"
                className="absolute inset-0 h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/90 via-foreground-950/30 to-transparent"></div>
              <div className="absolute bottom-0 left-0 right-0 p-5 md:p-7">
                <span className="rounded-full bg-primary-500 px-2.5 py-1 text-xs font-medium text-background-50">
                  {featured.tag}
                </span>
                <h3 className="mt-3 font-heading text-xl font-bold leading-snug text-background-50 md:text-2xl">
                  {featured.title}
                </h3>
                <p className="mt-2 hidden max-w-2xl text-sm text-background-100/80 md:block">
                  {featured.excerpt}
                </p>
              </div>
            </article>

            <div className="space-y-3 lg:col-span-1">
              {rest.slice(0, 3).map((n) => (
                <article
                  key={n.id}
                  className="rounded-lg border border-background-200 bg-background-100 p-4 transition-colors hover:border-primary-300"
                >
                  <span className="rounded-full bg-secondary-100 px-2 py-0.5 text-[10px] font-medium text-secondary-800">
                    {n.tag}
                  </span>
                  <h3 className="mt-2 line-clamp-2 font-heading text-sm font-bold leading-snug text-foreground-950">
                    {n.title}
                  </h3>
                  <div className="mt-2 flex items-center gap-3 text-xs text-foreground-500">
                    <span>{n.date}</span>
                    <span>
                      <i className="ri-eye-line mr-0.5"></i>
                      {(n.read / 1000).toFixed(1)}k
                    </span>
                  </div>
                </article>
              ))}
            </div>
          </div>
        )}

        {rest.length > 3 && (
          <div className="mt-5 grid grid-cols-1 gap-4 md:grid-cols-3">
            {rest.slice(3).map((n) => (
              <article
                key={n.id}
                className="rounded-lg border border-background-200 bg-background-100 p-4 transition-colors hover:border-primary-300"
              >
                <span className="rounded-full bg-secondary-100 px-2 py-0.5 text-[10px] font-medium text-secondary-800">
                  {n.tag}
                </span>
                <h3 className="mt-2 line-clamp-2 font-heading text-sm font-bold leading-snug text-foreground-950">
                  {n.title}
                </h3>
                <p className="mt-2 line-clamp-2 text-sm text-foreground-600">{n.excerpt}</p>
                <div className="mt-3 flex items-center justify-between text-xs text-foreground-500">
                  <span>{n.date}</span>
                  <span>
                    <i className="ri-eye-line mr-0.5"></i>
                    {(n.read / 1000).toFixed(1)}k
                  </span>
                </div>
              </article>
            ))}
          </div>
        )}

        {list.length === 0 && (
          <p className="mt-8 rounded-lg border border-background-200 bg-background-100 p-8 text-center text-sm text-foreground-600">
            该栏目暂无内容，看看其它分类吧。
          </p>
        )}
      </div>
    </section>
  );
}